import { i18n } from '../plugins/i18n'

// BusinessTypeモデルのid
const food = 1
const retail = 2
const hotel = 3
const salon = 4
const activity = 5
const others = 6

export const google = {
  name: i18n.t('labels.sites.google'),
  siteType: 'google',
  businessTypes: [food, retail, hotel, salon, activity, others]
} as const

const tripAdvisor = {
  name: i18n.t('labels.sites.tripAdvisor'),
  siteType: 'trip_advisor',
  businessTypes: [food, retail, hotel]
} as const

const tabelog = {
  name: i18n.t('labels.sites.tabelog'),
  siteType: 'tabelog',
  businessTypes: [food]
} as const

const retty = {
  name: i18n.t('labels.sites.retty'),
  siteType: 'retty',
  businessTypes: [food]
} as const

const hotPepperGourmet = {
  name: i18n.t('labels.sites.hotPepperGourmet'),
  siteType: 'hot_pepper_gourmet',
  businessTypes: [food]
} as const

const gnavi = {
  name: i18n.t('labels.sites.gnavi'),
  siteType: 'gnavi',
  businessTypes: [food]
} as const

const hotPepperBeauty = {
  name: i18n.t('labels.sites.hotPepperBeauty'),
  siteType: 'hot_pepper_beauty',
  businessTypes: [salon]
} as const

const yahooLoco = {
  name: i18n.t('labels.sites.yahooLoco'),
  siteType: 'yahoo_loco',
  businessTypes: [food, retail, hotel, salon, activity, others]
} as const

const yahooPlace = {
  name: i18n.t('labels.sites.yahooPlace'),
  siteType: 'yahoo_place',
  businessTypes: [food, retail, hotel, salon, activity, others]
} as const

const asoview = {
  name: i18n.t('labels.sites.asoview'),
  siteType: 'asoview',
  businessTypes: [activity]
} as const

const demaecan = {
  name: i18n.t('labels.sites.demaecan'),
  siteType: 'demaecan',
  businessTypes: [food]
} as const

const ikyu = {
  name: i18n.t('labels.sites.ikyu'),
  siteType: 'ikyu',
  businessTypes: [food]
} as const

const ozmall = {
  name: i18n.t('labels.sites.ozmall'),
  siteType: 'ozmall',
  businessTypes: [food]
} as const

const reportClinic = {
  name: i18n.t('labels.sites.reportClinic'),
  siteType: 'report_clinic',
  businessTypes: [salon]
} as const

const tribeau = {
  name: i18n.t('labels.sites.tribeau'),
  siteType: 'tribeau',
  businessTypes: [salon]
} as const

const docomo = {
  name: i18n.t('labels.sites.docomo'),
  siteType: 'docomo',
  businessTypes: [food]
} as const

const taishu_tenpyo = {
  name: i18n.t('labels.sites.taishuTenpyo'),
  siteType: 'taishu_tenpyo',
  businessTypes: [food, retail, hotel, salon, activity, others]
} as const

export const allSitesConst = [
  google,
  tripAdvisor,
  tabelog,
  retty,
  hotPepperGourmet,
  gnavi,
  hotPepperBeauty,
  yahooLoco,
  asoview,
  demaecan,
  ikyu,
  ozmall,
  reportClinic,
  tribeau,
  docomo,
  taishu_tenpyo,
  yahooPlace
] as const

export type SiteType = typeof allSitesConst[number]['siteType']
